import { types } from 'mobx-state-tree';

const BillingDetails = types.model({
  transactions: types.maybeNull(types.array(types.frozen())),
  refundTransactions: types.maybeNull(types.array(types.frozen())),
  nextPaymentDate: types.maybeNull(types.string),
  nextPaymentAmount: types.maybeNull(types.number),
  nextPaymentTransactionFee: types.maybeNull(types.number),
  nextPaymentTotal: types.maybeNull(types.number),
  // #37417: GO's already-billed open item (the agent's amount due now) / a term billed on GO's schedule.
  nextPaymentBilled: types.maybeNull(types.boolean),
  nextPaymentDueDate: types.maybeNull(types.string),
  // #37684: the part of totalRemaining GO billed before the cutover, for a note (informational, never gates anything).
  legacyBalanceDue: types.maybeNull(types.frozen()),
  legacyImportedTerm: types.maybeNull(types.boolean),
  // An agent's next installment is stamped with that installment, so it needs no Pay Ahead hold.
  directBillInstallmentPlan: types.maybeNull(types.boolean),
  nextPayments: types.optional(types.array(types.frozen()), []),
  totalInstallments: types.maybeNull(types.number),
  totalDue: types.maybeNull(types.number),
  totalRemaining: types.maybeNull(types.number),
  // #37632: the installment fees a payoff leaves out (stamped lines only; 0 otherwise).
  installmentFeePayoffWaiver: types.maybeNull(types.number),
  remainingPayments: types.maybeNull(types.number),
  activePaymentMethod: types.maybeNull(types.frozen()),
  allPaymentMethods: types.optional(types.array(types.frozen()), []),
  renewalPaymentDate: types.maybeNull(types.string)
});

export default BillingDetails;
